// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shepherd-button {
  background: #00bd9d;
  border: 0;
  border-radius: 3px;
  color: hsla(0, 0%, 100%, 0.75);
  cursor: pointer;
  margin-right: 0.5rem;
  padding: 0.5rem 1.5rem;
  transition: all 0.5s ease;
}

.shepherd-button:not(:disabled):hover {
  background: #196fcc;
  color: hsla(0, 0%, 100%, 0.75);
}

.shepherd-button.shepherd-button-secondary {
  background: #f1f2f3;
  color: rgba(0, 0, 0, 0.75);
}

.shepherd-button.shepherd-button-secondary:not(:disabled):hover {
  background: #d6d9db;
  color: rgba(0, 0, 0, 0.75);
}

.shepherd-button:disabled {
  cursor: not-allowed;
}

.shepherd-footer {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  justify-content: flex-end;
  padding: 0 0.75rem 0.75rem;
}

.shepherd-footer .shepherd-button:last-child {
  margin-right: 0;
}

.shepherd-cancel-icon {
  background: transparent;
  border: none;
  color: hsla(0, 0%, 50.2%, 0.75);
  font-size: 2em;
  cursor: pointer;
  font-weight: 400;
  margin: 0;
  padding: 0;
  transition: color 0.5s ease;
}

.shepherd-cancel-icon:hover {
  color: rgba(0, 0, 0, 0.75);
}

.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
  color: hsla(0, 0%, 50.2%, 0.75);
}

.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
  color: rgba(0, 0, 0, 0.75);
}

.shepherd-title {
  color: rgba(0, 0, 0, 0.75);
  display: flex;
  font-size: 1rem;
  font-weight: 400;
  flex: 1 0 auto;
  margin: 0;
  padding: 0;
}

.shepherd-header {
  align-items: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  justify-content: flex-end;
  line-height: 2em;
  padding: 0.75rem 0.75rem 0;
}

.shepherd-has-title .shepherd-content .shepherd-header {
  background: #e6e6e6;
  padding: 1em;
}

.shepherd-text {
  color: rgba(0, 0, 0, 0.75);
  font-size: 1rem;
  line-height: 1.3em;
  padding: 0.75em;
}

.shepherd-text p {
  margin-top: 0;
}

.shepherd-text p:last-child {
  margin-bottom: 0;
}

.shepherd-content {
  border-radius: 5px;
  outline: none;
  padding: 0;
}

.shepherd-element {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  opacity: 0;
  outline: none;
  transition: opacity 0.3s, visibility 0.3s;
  visibility: hidden;
  width: 100%;
  z-index: 9999;
}

.shepherd-enabled.shepherd-element {
  opacity: 1;
  visibility: visible;
}

.shepherd-element[data-popper-reference-hidden]:not(.shepherd-centered) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.shepherd-element, .shepherd-element *, .shepherd-element :after, .shepherd-element :before {
  box-sizing: border-box;
}

.shepherd-arrow, .shepherd-arrow:before {
  position: absolute;
  width: 16px;
  height: 16px;
  z-index: -1;
}

.shepherd-arrow:before {
  content: "";
  transform: rotate(45deg);
  background: #fff;
}

.shepherd-element[data-popper-placement^=top] > .shepherd-arrow {
  bottom: -8px;
}

.shepherd-element[data-popper-placement^=bottom] > .shepherd-arrow {
  top: -8px;
}

.shepherd-element[data-popper-placement^=left] > .shepherd-arrow {
  right: -8px;
}

.shepherd-element[data-popper-placement^=right] > .shepherd-arrow {
  left: -8px;
}

.shepherd-element.shepherd-centered > .shepherd-arrow {
  opacity: 0;
}

.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {
  background-color: #e6e6e6;
}

.shepherd-target-click-disabled.shepherd-enabled.shepherd-target, .shepherd-target-click-disabled.shepherd-enabled.shepherd-target * {
  pointer-events: none;
}

.shepherd-modal-overlay-container {
  height: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: fixed;
  top: 0;
  transition: all 0.3s ease-out, height 0ms 0.3s, opacity 0.3s 0ms;
  width: 100vw;
  z-index: 9997;
}

.shepherd-modal-overlay-container.shepherd-modal-is-visible {
  height: 100vh;
  opacity: 0.5;
  transition: all 0.3s ease-out, height 0s 0s, opacity 0.3s 0s;
}

.shepherd-modal-overlay-container.shepherd-modal-is-visible path {
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/shepherd.css"],"names":[],"mappings":"AAAA;EAAiB,mBAAA;EAAmB,SAAA;EAAS,kBAAA;EAAkB,8BAAA;EAA0B,eAAA;EAAe,oBAAA;EAAmB,sBAAA;EAAqB,yBAAA;AAShJ;;AATwK;EAAsC,mBAAA;EAAmB,8BAAA;AAcjO;;AAd2P;EAA2C,mBAAA;EAAmB,0BAAA;AAmBzT;;AAnB+U;EAAgE,mBAAA;EAAmB,0BAAA;AAwBla;;AAxBwb;EAA0B,mBAAA;AA4Bld;;AA3BA;EAAiB,8BAAA;EAA8B,+BAAA;EAA+B,aAAA;EAAa,yBAAA;EAAyB,0BAAA;AAmCpH;;AAnC4I;EAA6C,eAAA;AAuCzL;;AAtCA;EAAsB,uBAAA;EAAuB,YAAA;EAAY,+BAAA;EAA2B,cAAA;EAAc,eAAA;EAAe,gBAAA;EAAgB,SAAA;EAAS,UAAA;EAAU,2BAAA;AAkDpJ;;AAlD8K;EAA4B,0BAAA;AAsD1M;;AAtDgO;EAA4D,+BAAA;AA0D5R;;AA1DuT;EAAkE,0BAAA;AA8DzX;;AA7DA;EAAgB,0BAAA;EAAsB,aAAA;EAAa,eAAA;EAAe,gBAAA;EAAgB,cAAA;EAAc,SAAA;EAAS,UAAA;AAuEzG;;AAtEA;EAAiB,mBAAA;EAAmB,2BAAA;EAA2B,4BAAA;EAA4B,aAAA;EAAa,yBAAA;EAAyB,gBAAA;EAAgB,0BAAA;AAgFjJ;;AAhFyK;EAAuD,mBAAA;EAAmB,YAAA;AAqFnP;;AApFA;EAAe,0BAAA;EAAsB,eAAA;EAAe,kBAAA;EAAkB,eAAA;AA2FtE;;AA3FoF;EAAiB,aAAA;AA+FrG;;AA/FkH;EAA4B,gBAAA;AAmG9I;;AAlGA;EAAkB,kBAAA;EAAkB,aAAA;EAAa,UAAA;AAwGjD;;AAvGA;EAAkB,gBAAA;EAAgB,kBAAA;EAAkB,wCAAA;EAAoC,gBAAA;EAAgB,UAAA;EAAU,aAAA;EAAa,yCAAA;EAAsC,kBAAA;EAAkB,WAAA;EAAW,aAAA;AAoHlM;;AApH+M;EAAmC,UAAA;EAAU,mBAAA;AAyH5P;;AAzH+Q;EAAwE,UAAA;EAAU,oBAAA;EAAoB,kBAAA;AA+HrX;;AA/HuY;EAAyF,sBAAA;AAmIhe;;AAnIsf;EAAuC,kBAAA;EAAkB,WAAA;EAAW,YAAA;EAAY,WAAA;AA0ItkB;;AA1IilB;EAAuB,WAAA;EAAW,wBAAA;EAAwB,gBAAA;AAgJ3oB;;AAhJ2pB;EAA8D,YAAA;AAoJztB;;AApJquB;EAAiE,SAAA;AAwJtyB;;AAxJ+yB;EAA+D,WAAA;AA4J92B;;AA5Jy3B;EAAgE,UAAA;AAgKz7B;;AAhKm8B;EAAoD,UAAA;AAoKv/B;;AApKigC;EAA2F,yBAAA;AAwK5lC;;AAxKqnC;EAAoI,oBAAA;AA4KzvC;;AA3KA;EAAkC,SAAA;EAAS,OAAA;EAAO,UAAA;EAAU,gBAAA;EAAgB,oBAAA;EAAoB,eAAA;EAAe,MAAA;EAAM,gEAAA;EAA2D,YAAA;EAAY,aAAA;AAwL5L;;AAxLyM;EAA4D,aAAA;EAAa,YAAA;EAAW,4DAAA;AA8L7R;;AA9LqV;EAAiE,mBAAA;AAkMtZ","sourcesContent":[".shepherd-button{background:#00bd9d;border:0;border-radius:3px;color:hsla(0,0%,100%,.75);cursor:pointer;margin-right:.5rem;padding:.5rem 1.5rem;transition:all .5s ease}.shepherd-button:not(:disabled):hover{background:#196fcc;color:hsla(0,0%,100%,.75)}.shepherd-button.shepherd-button-secondary{background:#f1f2f3;color:rgba(0,0,0,.75)}.shepherd-button.shepherd-button-secondary:not(:disabled):hover{background:#d6d9db;color:rgba(0,0,0,.75)}.shepherd-button:disabled{cursor:not-allowed}\n.shepherd-footer{border-bottom-left-radius:5px;border-bottom-right-radius:5px;display:flex;justify-content:flex-end;padding:0 .75rem .75rem}.shepherd-footer .shepherd-button:last-child{margin-right:0}\n.shepherd-cancel-icon{background:transparent;border:none;color:hsla(0,0%,50.2%,.75);font-size:2em;cursor:pointer;font-weight:400;margin:0;padding:0;transition:color .5s ease}.shepherd-cancel-icon:hover{color:rgba(0,0,0,.75)}.shepherd-has-title .shepherd-content .shepherd-cancel-icon{color:hsla(0,0%,50.2%,.75)}.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover{color:rgba(0,0,0,.75)}\n.shepherd-title{color:rgba(0,0,0,.75);display:flex;font-size:1rem;font-weight:400;flex:1 0 auto;margin:0;padding:0}\n.shepherd-header{align-items:center;border-top-left-radius:5px;border-top-right-radius:5px;display:flex;justify-content:flex-end;line-height:2em;padding:.75rem .75rem 0}.shepherd-has-title .shepherd-content .shepherd-header{background:#e6e6e6;padding:1em}\n.shepherd-text{color:rgba(0,0,0,.75);font-size:1rem;line-height:1.3em;padding:.75em}.shepherd-text p{margin-top:0}.shepherd-text p:last-child{margin-bottom:0}\n.shepherd-content{border-radius:5px;outline:none;padding:0}\n.shepherd-element{background:#fff;border-radius:5px;box-shadow:0 1px 4px rgba(0,0,0,.2);max-width:400px;opacity:0;outline:none;transition:opacity .3s,visibility .3s;visibility:hidden;width:100%;z-index:9999}.shepherd-enabled.shepherd-element{opacity:1;visibility:visible}.shepherd-element[data-popper-reference-hidden]:not(.shepherd-centered){opacity:0;pointer-events:none;visibility:hidden}.shepherd-element,.shepherd-element *,.shepherd-element :after,.shepherd-element :before{box-sizing:border-box}.shepherd-arrow,.shepherd-arrow:before{position:absolute;width:16px;height:16px;z-index:-1}.shepherd-arrow:before{content:\"\";transform:rotate(45deg);background:#fff}.shepherd-element[data-popper-placement^=top]>.shepherd-arrow{bottom:-8px}.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow{top:-8px}.shepherd-element[data-popper-placement^=left]>.shepherd-arrow{right:-8px}.shepherd-element[data-popper-placement^=right]>.shepherd-arrow{left:-8px}.shepherd-element.shepherd-centered>.shepherd-arrow{opacity:0}.shepherd-element.shepherd-has-title[data-popper-placement^=bottom]>.shepherd-arrow:before{background-color:#e6e6e6}.shepherd-target-click-disabled.shepherd-enabled.shepherd-target,.shepherd-target-click-disabled.shepherd-enabled.shepherd-target *{pointer-events:none}\n.shepherd-modal-overlay-container{height:0;left:0;opacity:0;overflow:hidden;pointer-events:none;position:fixed;top:0;transition:all .3s ease-out,height 0ms .3s,opacity .3s 0ms;width:100vw;z-index:9997}.shepherd-modal-overlay-container.shepherd-modal-is-visible{height:100vh;opacity:.5;transition:all .3s ease-out,height 0s 0s,opacity .3s 0s}.shepherd-modal-overlay-container.shepherd-modal-is-visible path{pointer-events:all}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
